// import { Link } from 'react-router-dom';
import { useState } from 'react';
import { List } from 'semantic-ui-react';
import { Organisation } from '../../types/organisation';
import './OrganisationList.less';

export interface OrganisationListProps {
	data: Organisation[];
	onClick: (tenantId: string) => void;
}

export interface OrganisationListState {
	sortedData: Organisation[];
}

export const OrganisationList: React.FC<OrganisationListProps> = ({
	data,
	onClick,
}) => {
	const [sortedData] = useState(data);
	return (
		<List className='organisation-list' relaxed='very'>
			{sortedData &&
				sortedData.map((org) => (
					<List.Item
						key={org.id}
						onClick={() => {
							onClick(org.tenantId);
						}}
					>
						<List.Content>
							<List.Header>{org.name}</List.Header>
							<List.Description>
								{org.tenantId}.myspendingplanner.com.au
							</List.Description>
						</List.Content>
					</List.Item>
				))}
		</List>
	);
};
